import React from 'react';
import InlineSVG from 'react-inlinesvg';
import ArrowLeft from "../../assets/arrow_left.svg";
import './headerWithArrow.less';

const HeaderWithArrow = ({showArrow, arrowClicked, title}) => {

    const renderArrow = () => {
        return showArrow ? (
            <div className="header-icon" onClick={arrowClicked}>
                <InlineSVG src={ArrowLeft}></InlineSVG>
            </div>
        ) : <></>
    }

    const renderHeader = () => {
        return (
            <div className='header-title'>
                {title}
            </div>
        );
    }

    return (
        <div className='header-container'>
            {renderArrow()}
            {renderHeader()}
        </div>
    );
}

export default HeaderWithArrow;